export default __webpack_public_path__ + "static/media/wallet.89c4e0cf.png";